"use client";

import { useState, useEffect } from "react";
import Sidebar from "../../Component/Sidebar";
import IMAGES from "../../constants/images";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfile } from "../../redux/action/Profile";
import PersonalInfoUpdate from "../../Component/Profile/PersonalInfoUpdate";
import { uploadFile } from "../../redux/api/Upload/Image";
import { updateProfile } from "../../redux/api/Organisation/update";
import { Upload } from "antd";
import Model from "../../Component/Model";
import ProfessionalInfoTab from "../../Component/Profile/ProfessionalInfoTab";
import Notification from "./Notification";
import Security from "./Security";
import Preferance from "./Preferance";
import Privacy from "./Privacy";
import Support from "./Support";
import { navigateTo, getHref } from "../../utils/navigation";
import Deactivate from "./Deactivate";
import {
  User,
  Users,
  Bell,
  Shield,
  Settings,
  FileText,
  LogOut,
} from "lucide-react";

export default function Index() {
  const [activeTab, setActiveTab] = useState("personal");
  const [activeSettingTab, setActiveSettingTab] = useState("profile");
  const dispatch = useDispatch();
  const [editActive, setEditActive] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const { user, userLoading, userError } = useSelector(
    (state) => state.GET_USER_PROFILE
  );

  const getProfileData = () => {
    dispatch(getUserProfile());
  };

  useEffect(() => {
    getProfileData();
  }, []);

  // Settings navigation items
  const settingsNavItems = [
    { id: "profile", label: "Profile", icon: User, active: true },
    { id: "notifications", label: "Notification Settings", icon: Bell },
    { id: "security", label: "Account & Security", icon: Shield },
    { id: "preferences", label: "Preferences", icon: Settings },
    { id: "privacy", label: "Privacy & Data", icon: FileText },
    // { id: "support", label: "Support & Legal", icon: FileText },
    { id: "deactivate", label: "Deactivate / Delete Account", icon: LogOut },
  ];

  return (
    <div className="flex bg-[#FFFFFF] min-h-screen mt-[80px]">
      {/* Main Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-[calc(100vh/var(--app-zoom))] z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>

      {/* Main Content */}
      <div
        className={`flex-1 min-w-0 bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
          }`}
      >
        {/* Settings Inner Sidebar - Mobile Horizontal Scroll */}
        <div className="md:hidden bg-white rounded-t-[10px] overflow-x-auto scrollbar-hide">
          <div className="flex whitespace-nowrap px-2">
            {settingsNavItems.map((item) => (
              <div
                key={item.id}
                className={`py-4 px-4 flex-shrink-0 border-b-2 cursor-pointer ${item.id === activeSettingTab
                    ? "border-[#4B61FF] text-[#4B61FF] font-medium"
                    : "border-transparent text-[#334155]"
                  }`}
                onClick={() => setActiveSettingTab(item.id)}
              >
                <div className="flex items-center gap-2">
                  <span className="font-poppins text-[14px]">{item.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex gap-3 items-start">
          {/* Settings Inner Sidebar - Desktop */}
          <div className="hidden md:block w-60 flex-shrink-0 bg-white rounded-2xl border-[1px] border-solid border-[#E2E8F0] shadow-sm p-[10px]">
            <p className="text-[11px] uppercase tracking-wide font-semibold text-[#94A3B8] font-poppins px-[10px] pt-[6px] pb-[8px] mb-0">
              Settings
            </p>
            <div className="space-y-1">
              {settingsNavItems.map((item) => {
                const ItemIcon = item.icon;
                const isActive = item.id === activeSettingTab;
                const isDanger = item.id === "deactivate";
                return (
                  <div
                    key={item.id}
                    className={`flex items-center font-poppins gap-2.5 min-h-[40px] px-[10px] py-[8px] rounded-xl cursor-pointer transition-colors ${isActive
                        ? "bg-[#0F172A] text-white font-semibold shadow-md"
                        : isDanger
                          ? "text-[#DC2626] hover:bg-[#FEF2F2]"
                          : "text-[#334155] hover:bg-[#F1F5F9]"
                      }`}
                    onClick={() => setActiveSettingTab(item.id)}
                  >
                    <ItemIcon size={16} className="flex-shrink-0" />
                    <span className="font-poppins text-[13px] leading-tight">{item.label}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Profile Content */}
          {activeSettingTab === "profile" && (
            <div className="flex-1 min-w-0 bg-white pb-[40px] p-[20px] rounded-2xl border-[1px] border-solid border-[#E2E8F0] shadow-sm">
              <ProfileHeader
                editActive={editActive}
                setActiveTab={setActiveTab}
                setEditActive={setEditActive}
              />
              <ProfileDescription />

              {/* Tabs Navigation - hidden: only one tab ("personal", the default) is active */}
              <div className="hidden">
                {/* <button
                  onClick={() => setActiveTab("professional")}
                  className={`w-[168px] lg:w-[257px] h-[56px] flex  items-center gap-2 p-4 rounded-br-[0px] rounded-bl-[0px] ${
                    activeTab === "professional"
                      ? "text-white bg-[#4B61FF] "
                      : "text-[#334155] bg-[#FFFFFF] border-[1px] border-[#E2E8F0]"
                  }`}
                >
                  {activeTab === "professional" ? (
                    <div className="bg-[#6EE7B7] rounded-full p-1">
                      <Users className="h-4 w-4 text-[#4B61FF]" />
                    </div>
                  ) : (
                    <Users className="h-5 w-5" />
                  )}
                  <span className="text-[16px] font-poppins">
                    Professional Information
                  </span>
                </button> */}
              </div>

              {activeTab === "personal" ? (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 items-start">
                  <ProfilePicture />
                  <div className="md:col-span-2">
                    {editActive ? (
                      <PersonalInfoUpdate
                        editActive={editActive}
                        setEditActive={setEditActive}
                        user={user}
                      />
                    ) : (
                      <BasicInformation />
                    )}
                  </div>
                </div>
              ) : (
                <ProfessionalInfoTab />
              )}
            </div>
          )}
          {activeSettingTab === "notifications" && (
            <div className="flex-1 min-w-0 bg-white rounded-2xl border-[1px] border-solid border-[#E2E8F0] shadow-sm p-[20px]">
              <main className="h-screen bg-[#FFFFFF] py-0 w-full  ">
                <Notification />
              </main>
            </div>
          )}
          {activeSettingTab === "security" && (
            <div className="flex-1 min-w-0 bg-white rounded-2xl border-[1px] border-solid border-[#E2E8F0] shadow-sm p-[20px]">
              <main className="min-h-screen bg-[#FFFFFF]  w-full lg:w-1/2 ">
                <Security />
              </main>
            </div>
          )}
          {activeSettingTab === "preferences" && (
            <div className="flex-1 min-w-0 bg-white rounded-2xl border-[1px] border-solid border-[#E2E8F0] shadow-sm p-[20px] !h-screen">
              <main className="h-screen bg-[#FFFFFF]  w-full lg:w-1/2 ">
                <Preferance />
              </main>
            </div>
          )}
          {activeSettingTab === "privacy" && (
            <div className="flex-1 min-w-0 bg-white rounded-2xl border-[1px] border-solid border-[#E2E8F0] shadow-sm p-[20px]">
              <main className="min-h-screen bg-[#FFFFFF]  w-full lg:w-1/2 ">
                <Privacy />
              </main>
            </div>
          )}
          {activeSettingTab === "support" && (
            <div className="flex-1 min-w-0 bg-white rounded-2xl border-[1px] border-solid border-[#E2E8F0] shadow-sm p-[20px]">
              <main className="min-h-screen bg-[#FFFFFF]  w-full lg:w-1/2 ">
                <Support />
              </main>
            </div>
          )}
          {activeSettingTab === "deactivate" && (
            <div className="flex-1 min-w-0 bg-white rounded-2xl border-[1px] border-solid border-[#E2E8F0] shadow-sm p-[20px]">
              <main className="min-h-screen  w-full lg:w-1/2 ">
                <Deactivate />
              </main>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function ProfileHeader({ editActive, setActiveTab, setEditActive }) {
  return (
    <div className="flex justify-between items-center mb-1 gap-3">
      <div className="flex items-center gap-2.5">
        <div className="flex items-center justify-center w-[36px] h-[36px] rounded-xl bg-[#EFF6FF] text-[#2563EB] flex-shrink-0">
          <User size={18} />
        </div>
        <h1 className="text-xl font-bold text-[#171717] font-poppins mb-0">
          Profile
        </h1>
      </div>
      <div className="flex gap-2">
        {!editActive ? (
          <button
            variant="outline"
            className="flex items-center gap-2 bg-white text-[#171717] text-[13px] font-semibold font-poppins h-9 px-[14px] py-0 rounded-xl shadow-sm hover:bg-[#F8FAFC] transition-colors"
            style={{ border: "1px solid #E2E8F0" }}
            onClick={() => setEditActive(true)}
          >
            <img
              src={IMAGES.edit_icon || "/placeholder.svg"}
              alt="edit"
              className="h-4 w-4"
            />
            Edit
          </button>
        ) : null}
        <button
          className="btn-gradient text-white text-[13px] font-poppins font-semibold h-9 px-[14px] py-0 rounded-xl shadow-sm"
          href={getHref("/set-availability")}
          onClick={() => {
            navigateTo("/set-availability/available");
          }}
        >
          Set your availability
        </button>
      </div>
    </div>
  );
}

function ProfileDescription() {
  return (
    <>
      <p className="text-[#64748B] text-xs font-poppins font-normal mb-4 ml-[46px]">
        Update your personal and professional details to keep your profile
        accurate and discoverable by users.
      </p>
      <div className="border-t-[1px] border-solid border-x-0 border-b-0 border-[#F1F5F9] mt-0 mb-4" />
    </>
  );
}

function ProfilePicture() {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState(null);
  const [description, setDescription] = useState(null);
  const [icon, setIcon] = useState(null);
  const { user, userLoading, userError } = useSelector(
    (state) => state.GET_USER_PROFILE
  );
  const dispatch = useDispatch();

  const getProfileData = () => {
    dispatch(getUserProfile());
  };

  useEffect(() => {
    getProfileData();
  }, []);

  const handleChange = async (info) => {
    const file = info.file?.originFileObj;
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await dispatch(uploadFile(formData)).unwrap();

      if (res?.status === "success") {
        const imageUrl = res.message.payload;
        const userData = JSON.stringify({
          imageUrl: imageUrl,
          about: user?.about,

          title: user?.title,
          firstName: user?.firstName,
          lastName: user?.lastName,
          phoneNumber: user?.mobile,
          abhaNumber: user?.abhaNumber,
          counsellorRole: user?.counsellorRole,
          languages: user?.languages,
          country: user?.country,
          state: user?.state,
          pincode: user?.pincode,
          city: user?.city,
          address: user?.address,
        });
        dispatch(updateProfile(userData)).then((res) => {
          console.log("res=====", res.payload);
          if (res.payload.status === "success") {
            setShow(true);
            setMessage("Profile picture updated successfully");
            setDescription(
              "Your profile picture has been updated successfully"
            );
            setIcon(IMAGES.profile_success);
            navigateTo("/profile");
          } else {
            //message.error(res.payload.message.payload);
          }
        });
        // setUserImage(imageUrl);
        // setCreateUserImgUrl(imageUrl);
      } else {
        //message.error(res?.message?.payload);
      }
    } catch (err) {
      console.log(err);
      //message.error("Something went wrong!");
      // console.error(err);
    }
  };
  return (
    <div className="flex flex-col items-center bg-[#F8FAFC] border-[1px] border-solid border-[#F1F5F9] rounded-2xl p-[20px]">
      <h2 className="font-semibold mb-4 self-start text-[#171717] font-poppins text-[15px]">
        Profile Picture
      </h2>
      <div className="w-36 h-36 rounded-2xl overflow-hidden mb-4 bg-white shadow-md ring-4 ring-white">
        <img
          src={user?.imageUrl || "/placeholder.svg"}
          alt="Profile picture"
          className="w-full h-full object-cover"
        />
      </div>
      <p className="text-[15px] font-semibold text-[#171717] font-poppins mb-0 text-center">
        {user?.firstName} {user?.lastName}
      </p>
      <p className="text-xs text-[#64748B] font-poppins mb-4 text-center">
        {user?.counsellorRole}
      </p>
      <Upload
        accept=".jpg,.jpeg,.png"
        showUploadList={false}
        multiple={false}
        beforeUpload={() => true}
        customRequest={({ file, onSuccess }) => {
          handleChange({ file: { originFileObj: file } });
          // dummy success callback to avoid warning
          setTimeout(() => onSuccess("ok"), 0);
        }}
      >
        <button
          variant="outline"
          style={{
            height: "36px",
            padding: "0 16px",
            border: "1px solid #BFDBFE",
            color: "#2563EB",
            background: "#EFF6FF",
            borderRadius: "12px",
            fontFamily: "Poppins",
            fontWeight: 600,
            fontSize: "13px",
            width: "160px",
          }}
        >
          Change Picture
        </button>
      </Upload>
      <Model
        icon={icon}
        title={message}
        description={description}
        show={show}
        setShow={(v) => {
          setShow(v);
          window.location.href = "/profile";
        }}
      />
    </div>
  );
}

function BasicInformation() {
  const dispatch = useDispatch();
  const { user, userLoading, userError } = useSelector(
    (state) => state.GET_USER_PROFILE
  );
  const profileData = {
    name: user?.firstName + " " + user?.lastName,
    email: user?.email,
    phone: user?.mobile,
    license: user?.abhaNumber,
    role: user?.counsellorRole,
    languages: user?.languages,
    state: user?.state,
    city: user?.city,
    pincode: user?.pincode,
    address: user?.address,
    about: user?.about,
  };

  const getProfileData = () => {
    dispatch(getUserProfile());
  };

  useEffect(() => {
    getProfileData();
  }, []);

  return (
    <div className="bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl p-[20px]">
      <div className="flex items-center gap-2.5 mb-2">
        <div className="flex items-center justify-center w-[32px] h-[32px] rounded-lg bg-[#F0FDFA] text-[#0D9488] flex-shrink-0">
          <FileText size={16} />
        </div>
        <h2 className="text-[16px] font-semibold mb-0 text-[#171717] font-poppins">
          Basic Information
        </h2>
      </div>
      <div>
        <InfoField
          label="Name"
          value={profileData.name}
          classNameLabel="text-[#64748B] text-[13px] font-poppins font-normal"
          classNameValue={"text-[#2563EB] text-[14px] font-poppins font-semibold"}
        />
        <InfoField
          label="Email ID"
          value={profileData.email}
          classNameLabel="text-[#64748B] text-[13px] font-poppins font-normal"
          classNameValue={"text-[#171717] text-[14px] font-poppins font-medium"}
        />
        <InfoField
          label="Phone Number"
          value={profileData.phone}
          classNameLabel="text-[#64748B] text-[13px] font-poppins font-normal"
          classNameValue={"text-[#171717] text-[14px] font-poppins font-medium"}
        />
        <InfoField
          label="License Number/ABHA Number"
          value={profileData.license}
          classNameLabel="text-[#64748B] text-[13px] font-poppins font-normal"
          classNameValue={"text-[#171717] text-[14px] font-poppins font-medium"}
        />
        <InfoField
          label="Role"
          value={profileData.role}
          classNameLabel="text-[#64748B] text-[13px] font-poppins font-normal"
          classNameValue={"text-[#171717] text-[14px] font-poppins font-medium"}
        />
        <InfoField
          label="Languages Spoken"
          value={profileData.languages}
          classNameLabel="text-[#64748B] text-[13px] font-poppins font-normal"
          classNameValue={"text-[#171717] text-[14px] font-poppins font-medium"}
        />
        <InfoField
          label="State"
          value={profileData.state}
          classNameLabel="text-[#64748B] text-[13px] font-poppins font-normal"
          classNameValue={"text-[#171717] text-[14px] font-poppins font-medium"}
        />
        <InfoField
          label="City"
          value={profileData.city}
          classNameLabel="text-[#64748B] text-[13px] font-poppins font-normal"
          classNameValue={"text-[#171717] text-[14px] font-poppins font-medium"}
        />
        <InfoField
          label="Pincode"
          value={profileData.pincode}
          classNameLabel="text-[#64748B] text-[13px] font-poppins font-normal"
          classNameValue={"text-[#171717] text-[14px] font-poppins font-medium"}
        />
        <InfoField
          label="Address"
          value={profileData.address}
          classNameLabel="text-[#64748B] text-[13px] font-poppins font-normal"
          classNameValue={"text-[#171717] text-[14px] font-poppins font-medium"}
        />
        <InfoField
          label="About Yourself"
          value={profileData.about}
          classNameLabel="text-[#64748B] text-[13px] font-poppins font-normal"
          classNameValue={"text-[#171717] text-[14px] font-poppins font-medium"}
        />
      </div>
    </div>
  );
}

function InfoField({ label, value, classNameLabel, classNameValue }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-2 py-[12px] border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0">
      <div className={`${classNameLabel}`}>{label}</div>
      <div className={`md:col-span-2 font-medium text-right break-words ${classNameValue}`}>
        {value}
      </div>
    </div>
  );
}
